import { z } from 'zod';

export const StandardAnalyticEventCategorySchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  created: z.string().date(),
  updated: z.string().date(),
});

export type StandardAnalyticEventCategory = z.infer<typeof StandardAnalyticEventCategorySchema>;

export interface StandardAnalyticEventCategoryFindAllParams {
  q?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  orderDirection?: 'asc' | 'desc';
}
